import { render, staticRenderFns } from "./TheAuthorPage.vue?vue&type=template&id=6397e616&scoped=true"
import script from "./TheAuthorPage.vue?vue&type=script&lang=js"
export * from "./TheAuthorPage.vue?vue&type=script&lang=js"
import style0 from "./TheAuthorPage.vue?vue&type=style&index=0&id=6397e616&prod&lang=scss&scoped=true"
import style1 from "./TheAuthorPage.vue?vue&type=style&index=1&id=6397e616&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6397e616",
  null
  
)

export default component.exports